module.exports = __webpack_public_path__ + "media/images/icons/arrow-back-pink-ec7da26d1e6f7d517b053caad7b96904.svg";